import { TRANSFER_LIMIT_FOR_ALL } from '@wetransfer/transfer/constant/sizes';
import I18n from '@wetransfer/transfer/modules/i18n';

// The values returned from these functions should just be used
// for promoting plans, etc. Anything specific to the user should
// come from `user.rules`.

export function getProTransferLimit(): string {
  return I18n.size(TRANSFER_LIMIT_FOR_ALL);
}
